import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/author.png'
import _imports_1 from '@/assets/luna.png'


const _withScopeId = n => (_pushScopeId("data-v-7ccb9548"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "right" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "neck" }
const _hoisted_6 = { class: "tag-wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "tag-wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  style: {"width":"16px","height":"16px"},
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "text" }
const _hoisted_12 = ["innerHTML"]

import { ref, reactive } from "vue";
//接收父组件传过来的值,需要注意defineProps只能在setup语法糖里面使用，不需要import引入

export default /*#__PURE__*/_defineComponent({
  __name: 'newItem',
  props: {
  article: {
    type: Object,
    default: () => {}
  }
},
  setup(__props) {

const props = __props;


console.log(props.article, "props.article11111");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "avatar",
      src: __props.article.image_url?__props.article.image_url:'https://xiamenban.oss-cn-hangzhou.aliyuncs.com/official/empty.png',
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "title",
        innerHTML: __props.article.title
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(__props.article.author), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(__props.article.start_time.substr(0,10)), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "des",
        innerHTML: __props.article.abstract
      }, null, 8, _hoisted_12)
    ])
  ]))
}
}

})